import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Home from "../Routes/Home";
import Movies from "../Routes/Movies";
import Series from "../Routes/Series";
import MovieDetail from "../Routes/MovieDetail";
import SeriesDetail from "../Routes/SeriesDetail";
import ScrollToTop from "../Components/ScrollToTop";
import Community from "../Routes/Community";
import Shortz from "../Routes/Shortz";
import Watchlist from "../Routes/Watchlist";
import ErrorBoundary from "../Routes/ErrorBoundary";
import PrivacyPolicy from "../Routes/PrivacyPolicy";
import UserPosts from "../Routes/UserPosts";
import PersonDetails from "../Routes/PersonDetails";
import DeleteAccountPage from "../Routes/DeleteAccountPage";

const Routing = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <>
          <ScrollToTop />
          <Home />
        </>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/movies",
      element: (
        <>
          <ScrollToTop />
          <Movies />
        </>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/series",
      element: (
        <>
          <ScrollToTop />
          <Series />
        </>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/movies/:movieId/:movieName",
      element: (
        <>
          <ScrollToTop />
          <MovieDetail />
        </>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/series/:seriesId/:seriesName",
      element: (
        <>
          <ScrollToTop />
          <SeriesDetail />
        </>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/community",
      element: (
        <>
          <ScrollToTop />
          <Community />
        </>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/shortz",
      element: (
        <>
          <ScrollToTop />
          <Shortz />
        </>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/privacy-policy",
      element: (
        <>
          <ScrollToTop />
          <PrivacyPolicy />
        </>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/user-posts",
      element: (
        <>
          <ScrollToTop />
          <UserPosts />
        </>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/person/:personId/:personName",
      element: (
        <>
          <ScrollToTop />
          <PersonDetails />
        </>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/delete-account",
      element: (
        <>
          <ScrollToTop />
          <DeleteAccountPage />
        </>
      ),
    },
    // {
    //   path: "/watchlist",
    //   element: <Watchlist />,
    // },
    {
      path: "*",
      element: <Navigate to="/" />,
      errorElement: <ErrorBoundary />,
    },
  ]);
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};

export default Routing;
